/**
 * Where to send a user the instant they finish signing in.
 *
 * NOT `/`. The apex used to forward an onboarded signed-in visitor to their
 * shelves, and both sign-in paths leaned on that: they pushed `/` and let it
 * resolve. src/app/page.tsx deliberately stopped doing it — a signed-in visitor
 * who asks for rakemori.com wants the marketing page — which quietly turned
 * "you just signed in" into "here is the landing copy you were already looking
 * at", on web and in both native shells.
 *
 * `/login` is the route that still resolves a session to where it belongs:
 * /welcome when the username is unconfirmed, `/<libraryOwnerUsername>`
 * otherwise (src/app/login/page.tsx). Pushing the sign-in route *after* signing
 * in reads backwards for a second, which is why this constant exists rather
 * than the bare string: it is the app's own start URL too — the native shells'
 * server.url and the home-screen web app's manifest start_url — so a cold
 * launch by an already-signed-in user takes exactly this path.
 *
 * Keep the two branches server-side. A client that pushed straight to
 * `/<username>` would have to know whether onboarding is owed, and that answer
 * lives in the database (needsOnboarding reads `onboardedAt`) — a new Google
 * user would sail past /welcome into a library named by a username they never
 * agreed to.
 */
export const POST_SIGN_IN_PATH = "/login";
